export default __webpack_public_path__ + "static/media/transport-benefit-disabled.b213eb91.png";